Array.prototype.asyncForEach = function (onEach) {
  if (this.length === 0) {
    return
  }

  return new Promise(resolve => {
    this.forEach(async (each, index, list) => {
      await onEach(each, index)

      if (index === list.length - 1) {
        resolve()
      }
    })
  })
}

// https://shouts.dev/easiest-way-to-paginate-an-array-in-javascript
Array.prototype.paginate = function (currentPage, perPage) {
  currentPage = currentPage || 1
  perPage = perPage || 10

  const offsetStart = (currentPage - 1) * perPage
  const offsetEnd = currentPage * perPage
  const data = this.slice(offsetStart, offsetEnd)
  const totalPages = Math.ceil(this.length / perPage)
  const total = this.length

  return {
    currentPage,
    perPage,
    data,
    totalPages,
    offsetStart: offsetStart + 1,
    offsetEnd: Math.min(offsetEnd, total),
    previousPage: currentPage - 1 ? currentPage - 1 : null,
    nextPage: totalPages > currentPage ? currentPage + 1 : null,
    total,
  }
}
